exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.c-select[data-v-75020576] {\n  max-width: 500px;\n}\n.realtime-store-detail-max-width[data-v-75020576] {\n  margin-right: 0!important;\n}\n", ""]);

// exports
